import React, { Component } from 'react';
import GetRouter from './getRouter.js';
import {
    withRouter,
    Switch,
} from 'react-router-dom';

class SubRouter extends Component {
    componentWillMount() { }

    render() {
        const { routes } = this.props;
        return (
            <div>
                <Switch>
                    {routes.map((route, i) => (
                        <GetRouter key={i} {...route} />
                    ))}
                </Switch>
            </div>
        );
    }
}
export default SubRouter;